module.exports = "/static/fonts/OpenSans-SemiboldItalic.ttf";